import { MutationTree, ActionTree } from 'vuex/types';
import { IRootState } from '~/src/models/store';

export const state = (): IRootState => ({});

export const mutations: MutationTree<IRootState> = {};

export const actions: ActionTree<IRootState, IRootState> = {};
